<template>
  <div class="mt-26 md:mt-30.5! 2xl:mt-35!">
    <Hero v-if="heroImages" :images="heroImages" :buttons="buttons" />
    <Events v-if="eventsData?.items.length" :section-data="eventsData" />
    <Exhibition
      v-if="exhibitionData?.items.length"
      :section-data="exhibitionData"
    />
    <Publication
      v-if="publicationData?.items.length"
      :section-data="publicationData"
    />
    <Notification
      v-if="notificationData?.items.length"
      :section-data="notificationData"
    />
  </div>
</template>

<script setup lang="ts">
import type { HomepageSection } from '~/types'

definePageMeta({
  isHomePage: true,
})

const { data } = await usePersistedFetch('Homepage')
const breadcrumbsData = useBreadcrumbs()

onMounted(() => {
  breadcrumbsData.value = []
})

const homePageData = computed(() => data.value?.homepage?.sections || [])
const heroImages = computed(() => data.value?.homepage?.heroImage)
const buttons = computed(() => data.value?.homepage?.ctas)

const eventsData = computed(() => {
  return homePageData.value.find(
    (section: HomepageSection) =>
      section.content_type === 'Event' &&
      (!section.categories || section.categories.length === 0),
  )
})

const exhibitionData = computed(() => {
  return homePageData.value.find(
    (section: HomepageSection) =>
      section.content_type === 'Event' &&
      section.categories &&
      section.categories.length > 0,
  )
})

const publicationData = computed(() => {
  return homePageData.value.find(
    (section: HomepageSection) => section.content_type === 'Publication',
  )
})

const notificationData = computed(() => {
  return homePageData.value.find(
    (section: HomepageSection) => section.content_type === 'Announcement',
  )
})
</script>
